import React, { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import { post, get } from "../utils/helpers/http";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment';

const ServiceArea = () => {
  const [serviceAreas, setServiceAreas] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [currentWeek, setCurrentWeek] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [openServiceId, setOpenServiceId] = useState();
  const [checkedBoxes, setCheckedBoxes] = useState([]);
  const [errors, setErrors] = useState({});
  const [disableUpdatebtn, setDisableUpdateBtn] = useState(false)

  /**
   * @comment fetch the list of service area
   */
  const fetchServiceAreas = async () => {
    try {
      const response = await get('/ManageService/ServiceAreaList', {});
      setServiceAreas(response.data);
    } catch (error) {
      console.error("Error fetching service areas:", error);
    }
  };

  useEffect(() => {
    fetchServiceAreas();
    generateCurrentWeek(moment());
  }, []);

  /**
   * @param {*} id 
   * @comment delete service via id
   */
  const handleDeleteServiceArea = async (id) => {
    console.log("id of deleteing service area **", id);
    console.log("id of deleteing service area deleteId **", deleteId);
    // setShowDeleteModal(false);
    try {
      let body = { id: deleteId }
      const response = await post('/ManageService/DeleteServiceArea', body)
      console.log("response ManageService DeleteService Area ******", response)
      fetchServiceAreas();
      toast.success("Service Area deleted successfully");
    } catch (error) {
      console.error("Error deleting service area@@@@@", error);
    } finally {
      setShowDeleteModal(false);
    }
  };

  /**
   * @param {*} id 
   * @param {*} serviceName 
   * @param {*} postCodeFrom 
   * @param {*} postCodeTo 
   * @param {*} notAvailableFullDay 
   * @param {*} notAvailableTimeSlots 
   * @comments update service area
   */

  const handleUpdateServiceArea = async (id, serviceName, postCodeFrom, postCodeTo, notAvailableFullDay, notAvailableTimeSlots) => {
    try {
      if (!serviceName || !postCodeFrom || !postCodeTo) {
        toast.error("Please fill the required fields ");
      }
      let body = {
        id: id,
        serviceAreaName: serviceName,
        postCodeFrom: postCodeFrom,
        postCodeTo: postCodeTo,
        notAvailableFullDay: notAvailableFullDay,
        dateRangeFrom: new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)),
        dateRangeTo: endDate,
        notAvailableTimeSlots: notAvailableTimeSlots || [],
      }
      console.log("upsert service area body ***", body)
      const response = await post("/ManageService/AddUpdateServiceArea", body);
      console.log("response upsert service area** ", response)
      toast.success(response.data.message);
      if (response.data.message) {
        // fetchServiceAreas();
      }
    } catch (error) {
      console.log("upsert service area error ** ", error)
    }
  };

  /**
   * @param {*} area 
   * @comment update service time slot
   */
  const handleUpdate = (area) => {
    console.log("area *** update area ** ", area);
    const selectedCheckboxes = findSelectedCheckboxes();
    console.log(" selected Checkboxes******", selectedCheckboxes);
    handleUpdateServiceArea(area.id, area.serviceName, area.postCodeFrom, area.postCodeTo,
      selectedCheckboxes.length > 0, selectedCheckboxes);
  };

  const addNewArea = () => {
    console.log("before add new service area ** ", serviceAreas);
    const newServiceArea = {
      "id": 0, "serviceName": null, "postCodeFrom": null, "postCodeTo": null, "notAvailableFullDay": false,
      "isActive": true, "isDeleted": false, "createdOn": "", "updatedOn": null, "createdBy": null, "notAvailableTimeSlots": Array(currentWeek.length).fill(false)
    };
    setServiceAreas(prevServiceAreas => [...prevServiceAreas, newServiceArea]);
    setCheckedBoxes(new Array(currentWeek.length).fill(false)); // Initialize checkedBoxes state with false values for each day
    console.log("after add new service area ** ", serviceAreas);
  }

  /**
   * @param {*} index 
   * @param {*} field 
   * @param {*} value 
   * @comment update input fields // serviceName, postCodeTo postCodeFrom 
   */
  const handleFieldChange = (index, field, value) => {
    const updatedServiceAreas = [...serviceAreas];
    const updatedErrors = { ...errors };
    if (field === 'postCodeFrom' || field === 'postCodeTo') {
      if (value.trim() !== '') {
        if (/^\d{1,8}$/.test(value)) {
          updatedErrors[field] = '';
          updatedServiceAreas[index][field] = value;
        } else {
          updatedErrors[field] = 'Postcode should contain max 8 digits';
        }
      } else {
        updatedErrors[field] = '';
        updatedServiceAreas[index][field] = value;
      }
    } else if (field === 'serviceName') {
      const titleCaseValue = value.toLowerCase().replace(/\b(\w)/g, (char) => char.toUpperCase());
      updatedErrors[field] = '';
      updatedServiceAreas[index][field] = titleCaseValue.slice(0, 50);
    } else {
      updatedErrors[field] = '';
      updatedServiceAreas[index][field] = value.slice(0, 50);
    }
    setServiceAreas(updatedServiceAreas);
    setErrors(updatedErrors);
  };

  /**
   * @comment select accordion call api to fecth time slot data
   */
  const handleAccordionSelect = async (selectedIndex) => {
    setOpenServiceId(selectedIndex);
    console.log(`Accordion item selected ${selectedIndex ? 'API CALL' : ''} :`, selectedIndex);
    timeSlotList(selectedIndex);
  };
  useEffect(() => {
    timeSlotList()
  }, [startDate, endDate]);

  /**
   * @comments get time slot according to fromdate and todate with service id
   */
  const timeSlotList = async (selectedIndex) => {
    const body = {
      id: selectedIndex || openServiceId,
      from: new Date(new Date(startDate).setDate(new Date(startDate).getDate() + 1)),
      to: endDate
    }
    const response = await post("/ManageService/GetServiceAreaDetailById", body);
    console.log("get time slot****** ", response);
    checkSelectedCheckboxes(response.data.data.notAvailableTimeSlot)
  }

  const checkSelectedCheckboxes = (data) => {
    console.log(" ** updated Checked data *** ", data);
    const updatedCheckedBoxes = new Array(7).fill(false);

    if (data.length) {
      data.forEach(({ selectedDate, timeSlot }) => {
        const index = currentWeek.findIndex(date => moment(date, 'YYYY-MM-DD').isSame(selectedDate, 'day'));
        if (index !== -1 && timeSlot >= 1 && timeSlot <= 3) {
          const key = `${index}_${timeSlot}`;
          updatedCheckedBoxes[key] = true;
        }
      });
    }
    setCheckedBoxes(updatedCheckedBoxes);
  };

  useEffect(() => {
    const initialDate = moment();
    setCurrentWeek(generateCurrentWeek(initialDate));
    setCheckedBoxes(new Array(7).fill(false));
  }, []);

  const generateCurrentWeek = (date) => {
    const startDate = date.clone().startOf('isoWeek');
    setStartDate(startDate)
    const endDate = date.clone().endOf('isoWeek');
    console.log("startdate$$$", startDate);
    console.log("enddate$$$", endDate);
    setEndDate(endDate)
    const weekDates = [];
    const currentDate = startDate.clone();
    while (currentDate.isSameOrBefore(endDate)) {
      weekDates.push(currentDate.clone());
      currentDate.add(1, 'day');
    }
    return weekDates;
  };

  const nextWeek = () => {
    const nextWeekStartDate = currentWeek[6].clone().add(1, 'day');
    setCurrentWeek(generateCurrentWeek(nextWeekStartDate));
    console.log("next week ***", currentWeek)
    console.log("nextWeekStartDate ***", nextWeekStartDate)
  };

  const prevWeek = () => {
    console.log("previous week ***", currentWeek)

    const prevWeekStartDate = currentWeek[0].clone().subtract(7, 'days');
    setCurrentWeek(generateCurrentWeek(prevWeekStartDate));
    setCheckedBoxes({});
  };

  const handleCheckboxClick = (index, slot) => {
    const key = `${index}_${slot}`;
    const currentDate = moment().startOf('day');
    const clickedDate = currentWeek[index].startOf('day');
    if (clickedDate.isBefore(currentDate)) {
      return; // Do nothing for previous dates
    }

    setCheckedBoxes(prevCheckedBoxes => ({
      ...prevCheckedBoxes,
      [key]: !prevCheckedBoxes[key]
    }));
  };

  const findSelectedCheckboxes = () => {
    const selectedCheckboxes = [];
    for (const key in checkedBoxes) {
      if (checkedBoxes[key]) {
        const [index, slot] = key.split('_');
        selectedCheckboxes.push({
          selectedDate: currentWeek[index].format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'), // Get the date from currentWeek array
          timeSlot: parseInt(slot),
        });
      }
    }
    return selectedCheckboxes;
  }

  const isDatePassed = (providedDate, index) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
    const targetDate = new Date(providedDate);
    return targetDate < currentDate;
  }

  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth">
                  <h1 className="page-title">Manage Service Area</h1>
                </div>
              </div>
              <div className="page-content">
                <Accordion defaultActiveKey="0" onSelect={handleAccordionSelect}>
                  {serviceAreas.map((area, index) => (
                    <Accordion.Item key={index} eventKey={area.id.toString()}>
                      <Accordion.Header>{area.serviceName}</Accordion.Header>
                      <Accordion.Body>
                        <form>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-3">
                                <label className="form-label">
                                  Service area name
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  defaultValue={area.serviceName}
                                  onChange={(e) => handleFieldChange(index, 'serviceName', e.target.value)}
                                />
                                {errors['serviceName'] && <p className="error-text">{errors['serviceName']}</p>}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-3">
                                <label className="form-label w-100">
                                  Postcode
                                </label>
                                <div className="d-inline-flex postcodefields">
                                  <label className="pe-2 pt-3">From</label>
                                  <input
                                    type="text"
                                    value={area.postCodeFrom}
                                    className="form-control"
                                    onChange={(e) => handleFieldChange(index, 'postCodeFrom', e.target.value)}
                                  />
                                  <label className="ps-2 pe-2 pt-3">To</label>
                                  <input
                                    type="text"
                                    value={area.postCodeTo}
                                    className="form-control"
                                    onChange={(e) => handleFieldChange(index, 'postCodeTo', e.target.value)}
                                  />
                                </div>
                                <div>
                                  {(errors['postCodeFrom'] || errors['postCodeTo']) && (
                                    <p className="error-text">
                                      {errors['postCodeFrom'] || errors['postCodeTo']}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <h6>
                            Select dates and time slot when Laundry Go services
                            are not available.
                          </h6>
                          {/* <div className="checkbox mt-3">
                            <input
                              type="checkbox"
                              value="remember-me"
                              id="available"
                              defaultChecked={!area.notAvailableFullDay}
                            />
                            <label htmlFor="available">
                              Available for all days & time slots
                            </label>
                          </div> */}
                          <div class="availabilityCalendar">
                            <div class="acHeader">
                              <h5>{startDate.format('ddd D MMM')} – {endDate.format('ddd D MMM')}, {endDate.format('yyyy')}</h5>
                              <div>
                                <div className="actionbtnsclick">
                                  <a href="#" className="prevValue" onClick={prevWeek}><i className="fa-solid fa-chevron-left"></i></a>
                                  <a href="#" className="nextValue" onClick={nextWeek}><i className="fa-solid fa-chevron-right"></i></a>
                                </div>
                              </div>
                            </div>
                            <div class="acContent mt-3">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th className="text-start">Time Slots</th>
                                    {currentWeek.map((date, index) => (
                                      <th className="text-center" key={index}>{date.format('ddd D')}</th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="text-start">8am - 12pm</td>
                                    {currentWeek.map((date, index) => (
                                      <td className="text-center" key={index}>
                                        <div className="checkbox">
                                          <input
                                            type="checkbox"
                                            disabled={isDatePassed(date, index)}
                                            id={`timeSlot_${index}_1`}
                                            checked={checkedBoxes[`${index}_1`]}
                                            onChange={() => handleCheckboxClick(index, 1)}
                                          />
                                          <label htmlFor={`timeSlot_${index}_1`}>&nbsp;</label>
                                        </div>
                                      </td>
                                    ))}
                                  </tr>
                                  <tr>
                                    <td className="text-start">12pm - 4pm</td>
                                    {currentWeek.map((date, index) => (
                                      <td className="text-center" key={index}>
                                        <div className="checkbox">
                                          <input
                                            type="checkbox"
                                            id={`timeSlot_${index}_2`}
                                            disabled={isDatePassed(date, index)}
                                            checked={checkedBoxes[`${index}_2`]}
                                            onChange={() => handleCheckboxClick(index, 2)}
                                          />
                                          <label htmlFor={`timeSlot_${index}_2`}>&nbsp;</label>
                                        </div>
                                      </td>
                                    ))}
                                  </tr>
                                  <tr>
                                    <td className="text-start">4pm - 8pm</td>
                                    {currentWeek.map((date, index) => (
                                      <td className="text-center" key={index}>
                                        <div className="checkbox">
                                          <input
                                            type="checkbox"
                                            id={`timeSlot_${index}_3`}
                                            disabled={isDatePassed(date, index)}
                                            checked={checkedBoxes[`${index}_3`]}
                                            onChange={() => handleCheckboxClick(index, 3)}
                                          />
                                          <label htmlFor={`timeSlot_${index}_3`}>&nbsp;</label>
                                        </div>
                                      </td>
                                    ))}
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="mt-4 text-end">
                            <button className="btn btn-default deletebutton" type="button"
                              onClick={() => { setShowDeleteModal(true); setDeleteId(area.id); }}
                            > Delete </button>
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() => handleUpdate(area)}
                              disabled={disableUpdatebtn} >
                              Update
                            </button>
                          </div>
                        </form>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
                <button className="addbutton mt-2" onClick={() => addNewArea()}>
                  + Add New Service Area
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable
            onOpen={() => {
              setDisableUpdateBtn(true);
              setTimeout(() => {
                setDisableUpdateBtn(false);
              }, 5000);
            }}
          />
          <Footer />
        </div>
      </div>
      {showDeleteModal && (
        <div className="modal" tabIndex="-1" role="dialog" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete service area Confirmation</h5>
                <button type="button" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this service area?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleDeleteServiceArea}>Yes</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ServiceArea;
